import { render } from "./container-history-page-detail.vue?vue&type=template&id=08923c1a&scoped=true"
import script from "./container-history-page-detail.vue?vue&type=script&lang=js"
export * from "./container-history-page-detail.vue?vue&type=script&lang=js"

import "./container-history-page-detail.vue?vue&type=style&index=0&id=08923c1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08923c1a"]])

export default __exports__